import debounce from 'lodash/debounce'
import isElement from 'lodash/isElement'
import isString from 'lodash/isString'
import split from 'lodash/split'
import mapValues from 'lodash/mapValues'
import noop from 'lodash/noop'
import startsWith from 'lodash/startsWith'
import replace from 'lodash/replace'
import isArray from 'lodash/isArray'
import identity from 'lodash/identity'
import includes from 'lodash/includes'
import isUndefined from 'lodash/isUndefined'
import first from 'lodash/first'
import forEach from 'lodash/forEach'
import isNumber from 'lodash/isNumber'
import last from 'lodash/last'
import map from 'lodash/map'
import trim from 'lodash/trim'
import uniqBy from 'lodash/uniqBy'
import zipObject from 'lodash/zipObject'
import find from 'lodash/find'
import reject from 'lodash/reject'
import cloneDeep from 'lodash/cloneDeep'
import flatten from 'lodash/flatten'
import isEqual from 'lodash/isEqual'
import merge from 'lodash/merge'
import result from 'lodash/result'
import set from 'lodash/set'
import isObject from 'lodash/isObject'
import isFunction from 'lodash/isFunction'

export {
  debounce,
  isElement,
  isString,
  split,
  mapValues,
  noop,
  startsWith,
  replace,
  isArray,
  identity,
  includes,
  isUndefined,
  first,
  forEach,
  isNumber,
  last,
  map,
  trim,
  uniqBy,
  zipObject,
  find,
  reject,
  cloneDeep,
  flatten,
  isEqual,
  merge,
  result,
  set,
  isObject,
  isFunction
}
